/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".request-txt[_ngcontent-%COMP%]{font-size:22px;color:#303372;font-weight:700}.subtle[_ngcontent-%COMP%]{color:#a4a4a4;margin-bottom:5px}mat-error[_ngcontent-%COMP%]{font-size:13px;margin-top:-20px}mat-radio-group[_ngcontent-%COMP%]{margin-bottom:14px}"];
export { styles as styles };
